var exports = {
  "DZ": "Heading__wfc9v3",
  "nW": "Status__MAwZCm",
  "QB": "Message__0Oc7im",
};

module.exports = exports;
